import { FileType } from "src/api/types";

function isBlob(file: unknown): file is Blob {
  return file instanceof Blob;
}
function isFile(file: unknown): file is File {
  return file instanceof File;
}

export const convertToBlob = async (
  file: FileType["fileToUpload"]
): Promise<Blob> => {
  if (isBlob(file)) {
    return file;
  } else if (typeof file === "string") {
    const response = await fetch(file);
    return await response.blob();
  } else if (isFile(file)) {
    return file;
  }
  throw new Error("Unsupported file type");
};
